import { ReactComponent as Adult } from "assets/icons/adult.svg";

import { ReactComponent as Browser } from "assets/icons/browser.svg";
import { ReactComponent as Camera } from "assets/icons/camera.svg";
import { ReactComponent as Case } from "assets/icons/case.svg";
import { ReactComponent as Child } from "assets/icons/children.svg";
import { ReactComponent as Couples } from "assets/icons/couples.svg";
import { ReactComponent as CreditCard } from "assets/icons/credit-card.svg";
import { ReactComponent as Education } from "assets/icons/education.svg";
import { ReactComponent as Elder } from "assets/icons/elder.svg";
import { ReactComponent as Faith } from "assets/icons/faith.svg";
import { ReactComponent as Family } from "assets/icons/family.svg";
import { ReactComponent as File } from "assets/icons/file.svg";
import { ReactComponent as Globe } from "assets/icons/globe.svg";
import { ReactComponent as Groups } from "assets/icons/groups-regular.svg";

import { ReactComponent as Inbox } from "assets/icons/inbox.svg";
import { ReactComponent as Issues } from "assets/icons/issues.svg";
import { ReactComponent as Offline } from "assets/icons/offline.svg";
import americanExpressIcon from "assets/icons/payment/american-express-icon.svg";
import cashIcon from "assets/icons/payment/cash-icon.svg";
import masterCardIcon from "assets/icons/payment/master-card-icon.svg";
import venmoIcon from "assets/icons/payment/venmo-icon.svg";
import visaIcon from "assets/icons/payment/visa-icon.svg";
import zelleIcon from "assets/icons/payment/zelle-icon.svg";

import { ReactComponent as Phone } from "assets/icons/phone-gray.svg";
import { ReactComponent as Shield } from "assets/icons/shield.svg";

import { ReactComponent as Person } from "assets/icons/single-person.svg";
import { ReactComponent as Teen } from "assets/icons/teen.svg";
import { ReactComponent as Text } from "assets/icons/text.svg";

import { ReactComponent as Toddler } from "assets/icons/toddler.svg";
import { ReactComponent as Client } from "assets/icons/user-Regular.svg";
import { ReactComponent as Video } from "assets/icons/video-gray.svg";
import { ReactComponent as VideoStroke } from "assets/icons/video-Regular.svg";
import { ReactComponent as Wallet } from "assets/icons/wallet.svg";
import { FC } from "react";
import { ModalitiesEnum } from "types/therapist.types";
import { AgeCode } from "./options";

export const OPTIONS_ICONS: {
  name:
    | "telephone_session_availability"
    | "video_session_availability"
    | "online_chat_sessions_availability"
    | "in_person_session_availability";
  component: FC;
}[] = [
  { name: "in_person_session_availability", component: Offline },
  { name: "telephone_session_availability", component: Phone },
  { name: "video_session_availability", component: Video },
  { name: "online_chat_sessions_availability", component: Text },
];

export const THERAPIST_ICONS = {
  Issues,
  Camera,
  Globe,
  Faith,
  Groups,
  Shield,
  Client,
  VideoStroke,
  Person,
  Browser,
  Inbox,
  Wallet,
  CreditCard,
  File,
  Education,
  Case,
};

export const AGE_ICONS: {
  value: AgeCode;
  Icon: FC;
  label: string;
  age: string;
}[] = [
  {
    value: "toddler",
    Icon: Toddler,
    label: "Toddlers / Preschooler",
    age: "0-6 years",
  },
  { value: "child", Icon: Child, label: "Children", age: "6-10 years" },
  { value: "preteen", Icon: Teen, label: "Preteen /Tween", age: "11-13 years" },
  { value: "teen", Icon: Teen, label: "Teen", age: "14-19 years" },
  { value: "adult", Icon: Adult, label: "Adult", age: "20-65 years" },
  { value: "adults", Icon: Adult, label: "Adult", age: "20-65 years" },
  { value: "elder", Icon: Elder, label: "Elder 65+", age: "+65 years" },
];

export const MODALITY_ICONS = [
  {
    value: ModalitiesEnum.individuals,
    label: "Individuals",
    Icon: Person,
  },
  { value: ModalitiesEnum.couples, label: "Couples", Icon: Couples },
  { value: ModalitiesEnum.family, label: "Family", Icon: Family },
  { value: ModalitiesEnum.group, label: "Groups", Icon: Groups },
];

export const PAYMENT_ICONS = {
  visa: visaIcon,
  cash: cashIcon,
  mastercard: masterCardIcon,
  americanexpress: americanExpressIcon,
  zelle: zelleIcon,
  venmo: venmoIcon,
};
